export default __webpack_public_path__ + "static/Knocking-9d835063c4911b71a16c3c5da0c9dcc0.webp";